import React, { useState, useEffect } from "react";
import { Row, Col, Card, CardBody, Spinner } from "reactstrap";
// import rButton from "reactstrap/button";

import {
  deleteRequest,
  putRequest,
  postRequest,
  putRequestForm,
  RBButton,
  deleteConfirmationWords,
} from "components/Common/Utils";
import { useHistory, useParams, useLocation } from "react-router-dom";
import { Link, NavLink } from "react-router-dom";
import moment from "moment";
import Swal from "sweetalert2/dist/sweetalert2.js";
import { format } from "date-fns";
// import StarComponent from "./StarComponent";

import Lightbox from "react-image-lightbox";

import GridList from "@material-ui/core/GridList";
import GridListTile from "@material-ui/core/GridListTile";
import GridListTileBar from "@material-ui/core/GridListTileBar";

import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  IconButton,
  Avatar,
} from "@material-ui/core";
import DeleteIcon from "@material-ui/icons/Delete";

import LocationPicker from "react-location-picker";
// import DayTimePicker from "./DayTimePicker";

import { makeStyles } from "@material-ui/core/styles";
import { ToastContainer, toast } from "react-toastify";


import 'react-responsive-carousel/lib/styles/carousel.min.css';
import OrderDeliveryTable from "./OrderDeliveryTable";

export default function DeliveryAgentsDetails() {
  const location = useLocation();
  const state = location.state?.row;
  console.log(location.state);
  const [userAllDetails, setuserAllDetails] = useState(location.state);
  const [loader, setLoader] = useState(false);
  const [imageLB, setImage] = React.useState("");
  const [images, setImages] = React.useState([]);
  const [openLightbox, setOpenLightBox] = React.useState(false);

  const useStyles = makeStyles({
    tableHeader: {
      color: "#ffffff", // Use your preferred color
      backgroundColor: "#3f51b5", // Header background color
      fontWeight: "bold",
    },
    descriptionText: {
      fontSize: "0.8rem",
    },
    deleteIcon: {
      color: "red",
    },
    roundImage: {
      borderRadius: "50%",
      width: "75px",
      height: "75px",
    },
    roundImageSm: {
      borderRadius: "50%",
    },

    gridList: {
      width: "100%",
    },
    icon: {
      color: "rgba(255, 55, 25, 0.54)",
    },


  });





const formatDate = (dateString) => {
  const options = { year: "numeric", month: "long", day: "numeric" };
  return new Date(dateString).toLocaleDateString(undefined, options);
};

  const showLightBox = (image) => {
    setImage(image);
    setOpenLightBox(true);
  };


  const {
    first_name,
    last_name,
    image,
    country_code,
    gender,
    country,
    vehicleType,
vehicleInformation
,
    email,
    phone,
    status,
    createdAt,
    address,
  } = userAllDetails;


// console.log({state})

  return (
    <>
  
      <ToastContainer />
      <Row>
        <Col className="10">
          <div className="page-title-box">
            <h4>User Management</h4>
            <ol className="breadcrumb m-0">
              <li className="breadcrumb-item active">User Management</li>:{" "}
              <li className="breadcrumb-item">Delivery Agents details</li>
            </ol>
          </div>
        </Col>
        <div className="col-md-2 text-end">
          <button
            type="button"
            class="btn btn-primary btn-lg"
            onClick={() => history.back()}
          >
            <i class="fas fa-chevron-left"></i> Back
          </button>
        </div>

        {loader ? (
          <CardBody style={{ height: "100px" }}>
            <Spinner
              color="info"
              style={{
                height: "4rem",
                width: "4rem",
                position: "absolute",
                left: "50%",
              }}
            >
              Loading...
            </Spinner>
          </CardBody>
        ) : (
          <>
            <Card className="custom-card">
            {/* <div className="carousel-wrapper">

      <Carousel 
        autoPlay 
        infiniteLoop 
        showThumbs={false} 
        showStatus={false} 
        emulateTouch 
        dynamicHeight 
      >
        {images?.map((image, index) => (
          <div 
            key={index} 
            className="cover-image"
            style={{ 
              backgroundImage: `url(${image})`,  
            }}
          >
       
          </div>
        ))}
      </Carousel>
    </div> */}

<div
                className="cover-image"
                style={{ backgroundColor: "rgb(29, 155, 240)" }}
              ></div>




              <div className="profile-image">
                <img
                  src={
                    image
                      ? image
                      : `https://ui-avatars.com/api/?background=random&name=${
                          first_name + " " + last_name
                        }`
                  }
                  onClick={() =>
                    showLightBox(
                      image
                        ? image
                        : `https://ui-avatars.com/api/?background=random&name=${
                            first_name + " " + last_name
                          }`
                    )
                  }
                  alt="Image Not Available"
                />
              </div>
              <br></br>

              <div className="row my-2 py-2">
                <div
                  className="userinfo col-md-12 "
                  style={{ paddingLeft: "20px" }}
                >
                  <div className="fst">
                    {" "}
                    <h3> {first_name + " " + last_name} </h3>{" "}
                  </div>
                  <div className="row">
                    <div className="col-md-4 fst py-1">
                      {" "}
                      <p>
                        {" "}
                        Email: <span>{email}</span>{" "}
                      </p>{" "}
                    </div>
                    <div className="col-md-4 fst py-1">
                      {" "}
                      <p>
                        {" "}
                        Mobile: <span> {phone} </span>{" "}
                      </p>{" "}
                    </div>


                    <div className="col-md-4 fst py-1">
                      {" "}
                      <p>
                        {" "}
                        Status: <span> {status} </span>{" "}
                      </p>{" "}
                    </div> 


                    <div className="col-md-4 fst py-1">
                      {" "}
                      <p>
                        {" "}
                        Vehicle Type: <span> {vehicleType } </span>{" "}
                      </p>{" "}
                    </div>

              
                    <div className="col-md-4 fst py-1">
                      {" "}
                      <p>
                        {" "}
                        Vehicle Information: <span> {vehicleInformation} </span>{" "}
                      </p>{" "}
                    </div> 

                    <div className="col-md-4 fst py-1">
                      <p>
                        {" "}
                        Created At:
                        <span> {formatDate(createdAt)}</span>
                      </p>
                    </div>
                  </div>
               

        
                </div>
              </div>
            </Card>



          <Col md="12">
              <div
                id="exTab2"
                className="twitter-like-tabs2"
                style={{ background: "#ffff"}}
              >
                <ul
                  className="nav nav-pills"
                  style={{ width: "480px", display: "contents" }}
                >
                  <li className="active">
                    <a href="#Orders" data-toggle="tab">
                      {" "}
                  Orders
                    </a>
                  </li>

           
                </ul>
              </div>
            </Col>
       
            <Col md="12">
              <div className="tab-content clearfix">
                <div className="tab-pane active show padded-tab" id="Orders">             
                   <OrderDeliveryTable userId={userAllDetails._id} />
                </div>
              </div>
            </Col>
          </>
        )}

        {openLightbox && (
          <Lightbox
            mainSrc={imageLB}
            onCloseRequest={() => setOpenLightBox(false)}
          />
        )}
      </Row>
      <ToastContainer />{" "}
    </>
  );
}




